var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.comment.user_id === _vm.loggedInUserData.id
    ? _c("li", { staticClass: "current-user" }, [
        _c("div", { staticClass: "comment-wrap current-user" }, [
          _vm.comment.parent_comment_id
            ? _c("div", { staticClass: "comment-reply" }, [
                _c("div", { staticClass: "reply-label" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.getReplyName(_vm.comment.parent_comment_id))
                    )
                  ]),
                  _vm._v(
                    " - " +
                      _vm._s(_vm.getReplyDate(_vm.comment.parent_comment_id)) +
                      " "
                  )
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "reply-comment" }, [
                  _vm._v(
                    _vm._s(_vm.getReplyText(_vm.comment.parent_comment_id))
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "comment" },
            [
              _c("div", {
                staticClass: "comment-text",
                domProps: { innerHTML: _vm._s(_vm.comment.comments) }
              }),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "comment-button comment-reply-button",
                  class: { hide: _vm.showReplyEditor },
                  on: { click: _vm.clickReplyIcon }
                },
                [_c("i", { staticClass: "fas fa-reply" })]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "comment-button comment-trash-button",
                  attrs: { disabled: _vm.deleteCommentDisabled },
                  on: { click: _vm.clickDeleteComment }
                },
                [_c("i", { staticClass: "fas fa-trash" })]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "comment-date-wrapper" }, [
            _c("span", { staticClass: "comment-date" }, [
              _vm._v(_vm._s(_vm.commentDateTime))
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "comment-footer" },
            [
              _c(
                "b-collapse",
                {
                  attrs: {
                    id: "comment-reply-toggle-button-" + _vm.comment.id
                  },
                  model: {
                    value: _vm.showReplyEditor,
                    callback: function($$v) {
                      _vm.showReplyEditor = $$v
                    },
                    expression: "showReplyEditor"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "collapse-inner" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "comment-reply-toggle-button",
                          on: { click: _vm.clickHideReplyEditor }
                        },
                        [
                          _c("span", { staticClass: "not-collapsed" }, [
                            _c("i", { staticClass: "fas fa-times" })
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "comment-reply-wrap" }, [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.replyText,
                              expression: "replyText"
                            }
                          ],
                          staticClass: "comment-input",
                          attrs: {
                            id: "comment-reply-" + _vm.comment.id,
                            rows: "1",
                            name: "comment-reply-" + _vm.comment.id,
                            placeholder: "Reply to this comment"
                          },
                          domProps: { value: _vm.replyText },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.replyText = $event.target.value
                              },
                              function($event) {
                                return _vm.resizeInput($event.target)
                              }
                            ],
                            keydown: [
                              function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                if (
                                  $event.ctrlKey ||
                                  $event.shiftKey ||
                                  $event.altKey ||
                                  $event.metaKey
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                              },
                              function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                if (!$event.shiftKey) {
                                  return null
                                }
                                if (
                                  $event.ctrlKey ||
                                  $event.altKey ||
                                  $event.metaKey
                                ) {
                                  return null
                                }
                                return _vm.newline.apply(null, arguments)
                              }
                            ],
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              if (
                                $event.ctrlKey ||
                                $event.shiftKey ||
                                $event.altKey ||
                                $event.metaKey
                              ) {
                                return null
                              }
                              return _vm.commentReplySubmitted.apply(
                                null,
                                arguments
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "comment-controls" },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "comment-button",
                                attrs: {
                                  id: "comment-reply-" + _vm.comment.id,
                                  "data-parent-id": _vm.comment.id,
                                  disabled: _vm.replyButtonDisabled
                                },
                                on: { click: _vm.commentReplySubmitted }
                              },
                              [_c("i", { staticClass: "fas fa-paper-plane" })]
                            ),
                            _vm._v(" "),
                            _c("emoji-picker", {
                              staticClass: "emoji-picker-outer",
                              attrs: { search: _vm.emojiSearch },
                              on: { emoji: _vm.insertEmoji },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "emoji-invoker",
                                    fn: function(ref) {
                                      var clickEvent = ref.events.click
                                      return _c(
                                        "button",
                                        {
                                          staticClass: "emoji-invoker",
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return clickEvent.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "far fa-smile"
                                          })
                                        ]
                                      )
                                    }
                                  },
                                  {
                                    key: "emoji-picker",
                                    fn: function(ref) {
                                      var emojis = ref.emojis
                                      var insert = ref.insert
                                      var display = ref.display
                                      return _c(
                                        "div",
                                        { staticClass: "emoji-picker" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "emoji-search-wrap"
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.emojiSearch,
                                                    expression: "emojiSearch"
                                                  }
                                                ],
                                                attrs: {
                                                  type: "text",
                                                  placeholder: "Search Emoji"
                                                },
                                                domProps: {
                                                  value: _vm.emojiSearch
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.emojiSearch =
                                                      $event.target.value
                                                  }
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "emoji-list-wrap" },
                                            _vm._l(emojis, function(
                                              emojiGroup,
                                              category
                                            ) {
                                              return _c(
                                                "div",
                                                {
                                                  key: category,
                                                  staticClass: "emoji-category"
                                                },
                                                [
                                                  _c("h5", [
                                                    _vm._v(_vm._s(category))
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "emoji-category-content"
                                                    },
                                                    _vm._l(emojiGroup, function(
                                                      emoji,
                                                      emojiName
                                                    ) {
                                                      return _c(
                                                        "span",
                                                        {
                                                          key: emojiName,
                                                          attrs: {
                                                            title: emojiName
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.insertEmoji(
                                                                emoji
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v(_vm._s(emoji))]
                                                      )
                                                    }),
                                                    0
                                                  )
                                                ]
                                              )
                                            }),
                                            0
                                          )
                                        ]
                                      )
                                    }
                                  }
                                ],
                                null,
                                false,
                                1448733771
                              )
                            })
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ])
      ])
    : _c("li", { staticClass: "other-user" }, [
        false
          ? _c("div", { staticClass: "user-icon-wrap" }, [
              _c("div", { staticClass: "user-icon" }, [
                _c("span", { staticClass: "user-icon-inner" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.getInitials(_vm.comment.name)) +
                      "\n        "
                  )
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "comment-wrap other-user" }, [
          _vm.comment.parent_comment_id
            ? _c("div", { staticClass: "comment-reply" }, [
                _c("div", { staticClass: "reply-label" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.getReplyName(_vm.comment.parent_comment_id))
                    )
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(_vm.getReplyDate(_vm.comment.parent_comment_id)) +
                      " "
                  )
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "reply-comment" }, [
                  _vm._v(
                    _vm._s(_vm.getReplyText(_vm.comment.parent_comment_id))
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "comment-header" }, [
            _c("span", { staticClass: "comment-user" }, [
              _vm._v(_vm._s(_vm.comment.name))
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "comment-date" }, [
              _vm._v(_vm._s(_vm.commentDateTime))
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "comment" },
            [
              _c("div", {
                staticClass: "comment-text",
                domProps: { innerHTML: _vm._s(_vm.comment.comments) }
              }),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "comment-button comment-reply-button",
                  class: { hide: _vm.showReplyEditor },
                  on: { click: _vm.clickReplyIcon }
                },
                [_c("i", { staticClass: "fas fa-reply" })]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "comment-footer" },
            [
              _c(
                "b-collapse",
                {
                  attrs: {
                    id: "comment-reply-toggle-button-" + _vm.comment.id
                  },
                  model: {
                    value: _vm.showReplyEditor,
                    callback: function($$v) {
                      _vm.showReplyEditor = $$v
                    },
                    expression: "showReplyEditor"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "collapse-inner" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "comment-reply-toggle-button",
                          on: { click: _vm.clickHideReplyEditor }
                        },
                        [
                          _c("span", { staticClass: "not-collapsed" }, [
                            _c("i", { staticClass: "fas fa-times" })
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "comment-reply-wrap" },
                        [
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.replyText,
                                expression: "replyText"
                              }
                            ],
                            staticClass: "comment-input",
                            attrs: {
                              id: "comment-reply-" + _vm.comment.id,
                              rows: "1",
                              name: "comment-reply-" + _vm.comment.id,
                              placeholder: "Reply to this comment"
                            },
                            domProps: { value: _vm.replyText },
                            on: {
                              input: [
                                function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.replyText = $event.target.value
                                },
                                function($event) {
                                  return _vm.resizeInput($event.target)
                                }
                              ],
                              keydown: [
                                function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  if (
                                    $event.ctrlKey ||
                                    $event.shiftKey ||
                                    $event.altKey ||
                                    $event.metaKey
                                  ) {
                                    return null
                                  }
                                  $event.preventDefault()
                                },
                                function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  if (!$event.shiftKey) {
                                    return null
                                  }
                                  if (
                                    $event.ctrlKey ||
                                    $event.altKey ||
                                    $event.metaKey
                                  ) {
                                    return null
                                  }
                                  return _vm.newline.apply(null, arguments)
                                }
                              ],
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                if (
                                  $event.ctrlKey ||
                                  $event.shiftKey ||
                                  $event.altKey ||
                                  $event.metaKey
                                ) {
                                  return null
                                }
                                return _vm.commentReplySubmitted.apply(
                                  null,
                                  arguments
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "comment-button",
                              attrs: {
                                id: "comment-reply-" + _vm.comment.id,
                                "data-parent-id": _vm.comment.id,
                                disabled: _vm.replyButtonDisabled
                              },
                              on: { click: _vm.commentReplySubmitted }
                            },
                            [_c("i", { staticClass: "fas fa-paper-plane" })]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ])
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }